import type { TableColumn, TableColumnVisibility } from '@ipfabric/utils';
import { makeIsColumnVisible } from 'components/Table/helpers/makeIsColumnVisible';

export const hasSomeColumnAppeared = (
  columns: TableColumn<any>[],
  prevColumnVisibility: TableColumnVisibility | undefined,
  nextColumnVisibility: TableColumnVisibility | undefined,
): boolean =>
  columns.some(
    (column) =>
      !makeIsColumnVisible(prevColumnVisibility)(column) &&
      makeIsColumnVisible(nextColumnVisibility)(column),
  );
